import SortPopup, { SortOption } from "../../../../components/sort_popup/sort_popup";

export type AmiForYouSortOption = "newest" | "oldest" | "nameAsc" | "nameDesc";

export const DEFAULT_AMIFORYOU_SORT_OPTION: AmiForYouSortOption = "newest";

const OPTIONS: SortOption<AmiForYouSortOption>[] = [
  { value: "newest", label: "New to old" },
  { value: "oldest", label: "Old to new" },
  { value: "nameAsc", label: "Name (A-Z)" },
  { value: "nameDesc", label: "Name (Z-A)" },
];

export function amiForYouSortOptionLabel(option: AmiForYouSortOption): string {
  return OPTIONS.find((o) => o.value === option)!.label;
}

export function amiForYouSortOptionToParams(option: AmiForYouSortOption): {
  sortBy: "created_at" | "title";
  sortOrder: "ASC" | "DESC";
} {
  switch (option) {
    case "newest":
      return { sortBy: "created_at", sortOrder: "DESC" };
    case "oldest":
      return { sortBy: "created_at", sortOrder: "ASC" };
    case "nameAsc":
      return { sortBy: "title", sortOrder: "ASC" };
    case "nameDesc":
      return { sortBy: "title", sortOrder: "DESC" };
  }
}

export default function SortAmiForYouPopup({
  open,
  onClose,
  sortOption,
  setSortOption,
}: {
  open: boolean;
  onClose: () => void;
  sortOption: AmiForYouSortOption;
  setSortOption: (option: AmiForYouSortOption) => void;
}) {
  return (
    <SortPopup
      open={open}
      onClose={onClose}
      title="Sort AMI For You"
      options={OPTIONS}
      value={sortOption}
      onApply={setSortOption}
    />
  );
}
